import {
  Box,
  Grid,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { Icons, Images } from "assets";
import classNames from "classnames";
import useWindowSize from "shared/customHooks/windowSize";
import BookFilters from "../BooksFilter";
import styles from "./style.module.scss";
import TablePagination from "@mui/material/TablePagination";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { routeConstant } from "shared/routes/routesConstant";

let book_type = {
  free: 1,
  premium: 2,
};

function RecentTransactionGrid() {
  const navigate = useNavigate();
  const screenWidth = useWindowSize();
  const [page, setPage] = useState<number>(2);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [loader, setLoader] = useState<boolean>(false);

  useEffect(() => {
    setLoader(true);
    setTimeout(() => {
      setLoader(false);
    }, 2000);
  }, []);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const book_status = {
    pending: 1,
    published: 2,
  };

  let books = [
    {
      book_type: 1,
      status: 1,
    },
    {
      book_type: 2,
      status: 2,
    },
    {
      book_type: 1,
      status: 1,
    },
    {
      book_type: 2,
      status: 2,
    },
  ];

  return (
    <div className={styles.mainContainer}>
      <div className={styles.mainTableContainer}>
        <Box className={styles.topHeadingContainer}>
          <div>
            <div className={styles.heading}>Recent Books List</div>
            <div className={styles.subHeading}>
              View All recent Books list and you can publish or reject book.
            </div>
          </div>
          <div className={styles.btnContainer}>
            <button
              className={styles.viewAllBtn}
              onClick={()=>navigate(routeConstant.allBooksListings.path)}
            >
              View All
            </button>
            <button
              className={styles.viewAllBtn}
              onClick={()=>navigate(routeConstant.manageBooks.path)}
            >
              Manage Books
            </button>
          </div>
        </Box>

        <BookFilters />

        <div className={styles.bookCounter}>
          Showing “<span>84 Books</span>”
        </div>

        <TableContainer
          component={Paper}
          sx={screenWidth > 990 ? { width: `${screenWidth - 300}px` } : {}}
          className={styles.tableContainer}
          id="table-view-dashboard"
        >
          <Table>
            <TableHead className={styles.tableHead}>
              <TableRow>
                <TableCell>Book Name</TableCell>
                <TableCell>Publication House</TableCell>
                <TableCell>Book Type</TableCell>
                <TableCell>Price</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={styles.tableBody}>
              {loader ? (
                <Loader />
              ) : (
                books?.map((item: any, index: number, arr: any[]) => {
                  return (
                    <TableRow>
                      <TableCell className={styles.biggerCell}>
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={Images.DefaultBookImg}
                            alt="profile_picture"
                            className={styles.bookImg}
                          />
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "2px",
                            }}
                          >
                            <label className={styles.bookName}>Book Name</label>

                            <label className={styles.authorName}>
                              by <span>Author Name</span>
                            </label>
                          </div>
                        </div>
                      </TableCell>

                      <TableCell>
                        <label className={styles.publishingHouse}>
                          Publishing House
                        </label>
                      </TableCell>

                      <TableCell className={classNames(styles.statusCell)}>
                        <label
                          className={
                            item?.book_type === book_type.free
                              ? styles.freeBookTag
                              : item?.book_type === book_type.premium
                              ? styles.premiumBookTag
                              : ""
                          }
                        >
                          {item?.book_type === book_type.free
                            ? "Free"
                            : item?.book_type === book_type.premium
                            ? "Premium"
                            : ""}
                        </label>
                      </TableCell>

                      <TableCell>
                        <Grid container spacing={1}>
                          <Grid item xs={6}>
                            <label className={styles.darkPurple}>
                              Buy Price:
                            </label>
                          </Grid>
                          <Grid item xs={6}>
                            <label className={styles.darkPurple}>
                              00 Coins
                            </label>
                          </Grid>
                          <Grid item xs={6}>
                            <label className={styles.pink}>Borrow Price:</label>
                          </Grid>
                          <Grid item xs={6}>
                            <label className={styles.pink}>00 Coins</label>
                          </Grid>
                        </Grid>
                      </TableCell>

                      <TableCell className={classNames(styles.statusCell)}>
                        <label
                          className={
                            item?.status === book_status.pending
                              ? styles.pending
                              : item?.status === book_status.published
                              ? styles.approved
                              : ""
                          }
                        >
                          {item?.status === book_status.pending
                            ? "Pending"
                            : item?.status === book_status.published
                            ? "Published"
                            : "----"}
                        </label>
                      </TableCell>
                      <TableCell>
                        <div className={styles.actionContainer}>
                          <Tooltip arrow title="View">
                            <div>
                              <Icons.EyeIcon2 />
                            </div>
                          </Tooltip>
                          <Tooltip arrow title="Info">
                            <div>
                              <Icons.InfoTableIcon />
                            </div>
                          </Tooltip>
                          <Tooltip arrow title="Play Book">
                            <div>
                              <Icons.PlayCircleIcon />
                            </div>
                          </Tooltip>
                          <Tooltip arrow title="Publish">
                            <div>
                              <Icons.ApproveIcon />
                            </div>
                          </Tooltip>
                          <Tooltip arrow title="Un-Publish">
                            <div>
                              <Icons.RejectIcon />
                            </div>
                          </Tooltip>
                          <Tooltip arrow title="Delete Book">
                            <div>
                              <Icons.DeleteIcon />
                            </div>
                          </Tooltip>
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <div className={styles.paginationContainer}>
          <TablePagination
            component="div"
            count={100}
            page={page}
            className={styles.pagination}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            SelectProps={{
              className: styles.paginationDropdown,
            }}
            nextIconButtonProps={{
              className: styles.nextBtn,
            }}
            backIconButtonProps={{
              className: styles.backBtn,
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default RecentTransactionGrid;

const Loader = () => {
  return (
    <>
      {Array.from({ length: 3 }).map((item, index) => {
        return (
          <TableRow className={styles.loadingRow}>
            <TableCell>
              <div style={{ display: "flex", gap: "4px" }}>
                <Skeleton variant="rounded" width={40} height={40} />
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <Skeleton variant="rectangular" width={120} height={20} />
                  <Skeleton variant="rectangular" width={120} height={10} />
                </div>
              </div>
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={120} height={10} />
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={60} height={10} />
            </TableCell>
            <TableCell>
              <div style={{ display: "flex", gap: "5px" }}>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    flexDirection: "column",
                  }}
                >
                  <Skeleton variant="rectangular" width={120} height={20} />
                  <Skeleton variant="rectangular" width={120} height={20} />
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    flexDirection: "column",
                  }}
                >
                  <Skeleton variant="rectangular" width={120} height={20} />
                  <Skeleton variant="rectangular" width={120} height={20} />
                </div>
              </div>
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={60} height={10} />
            </TableCell>
            <TableCell>
              <div className={styles.actionContainer} style={{ gap: "5px" }}>
                <Skeleton variant="circular" width={35} height={35} />
                <Skeleton variant="circular" width={35} height={35} />
                <Skeleton variant="circular" width={35} height={35} />
                <Skeleton variant="circular" width={35} height={35} />
                <Skeleton variant="circular" width={35} height={35} />
              </div>
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
};
